import api from "../api";

export default {
    show() {
        return api.get(`/central/ticket-fees/default`)
    }
}
